import { compose, graphql } from 'react-apollo';
import { UPDATE_USER } from '../graphql';

export default compose(graphql(UPDATE_USER, { name: 'updateUser' }));
